export const FormField = ({ label, children, required = false, className = "" }) => (
    <div className={`flex items-center gap-1.5 ${className}`}>
        <label className="w-[78px] text-[11px] font-medium text-slate-700 text-left shrink-0 truncate" title={label}>
            {label}{required && <span className="text-rose-500 ml-0.5">*</span>}
        </label>
        <div className="flex-1 min-w-0">
            {children}
        </div>
    </div>
);